/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
} from 'react-native';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import Faq from '../../components/misc/Faq';

class Help extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Help';
  }

  render() {
    const { history } = this.props;

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_help')}
          hasCancel
          history={history}
        />

        <Faq prefix="faq" />
      </View>
    );
  }
}

Help.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Help;
